export default __webpack_public_path__ + "static/media/quikstart-5.30cc315e.svg";